import { z } from 'zod'

export const VServerTierSlug = z.enum([
  'vserver-xs',
  'vserver-s',
  'vserver-m',
  'vserver-l',
  'vserver-xl'
])
export type VServerTierSlug = z.infer<typeof VServerTierSlug>

export const VServerFeatures = z.object({
  type: z.literal('vserver'),
  vcpu: z.number(),
  ramGiB: z.number(),
  diskGB: z.number(),
  snapshots: z.number(),
  popular: z.boolean().optional()
})
export type VServerFeatures = z.infer<typeof VServerFeatures>

export function isVServerFeatures(
  features: Record<string, unknown> | undefined
): features is VServerFeatures {
  if (!features) return false
  return features.type === 'vserver'
}
